import React, { useEffect, useState, useContext } from 'react';
import { loadFromCache, loadTitleCache ,deleteFromCache} from './CacheHandler';
import { ModeContext } from './ModeContext';
import Button from '@mui/material/Button';
import { IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import Collapse from '@mui/material/Collapse';
import { SendToCosmos } from './SendToCosmos';

const historySection = [
  { key: 'today', label: '今日', messagesKey: 'today' },
  { key: 'yesterday', label: '昨日', messagesKey: 'yesterday' },
  { key: 'last7Days', label: '1週間以内', messagesKey: 'last7Days' },
  { key: 'last30Days', label: '1ケ月以上', messagesKey: 'last30Days' }
];

const SidebarHistory = () => {
  const { mode, setMode,
    sessionId, setSessionId,
    messages, setMessages,
    chatHistory,setChatHistory,
    user,
    displayMode, setDisplayMode,
    setIsUploadMode,
    setActiveButton,
    loginInfo } = useContext(ModeContext);


  const [openSections, setOpenSections] = useState({
    today: true,
    yesterday: true,
    last7Days: true,
    last30Days: true,
  });

  // キャッシュから履歴を読み込む
  useEffect(() => {
    loadTitleCache('chat-history-cache').then((data) => {
      //console.log('Sidebar_data',data)
      if (data) {
        const filteredData = data
          .map((chat) => {
            //const firstUserMessage = chat.messages.find((msg) => msg.sender === 'user');
            return chat
              ? {
                  id: chat.id,
                  title: chat.title,
                  messages: chat.text,
                  mode: chat.mode,
                  timestamp: chat.timestamp || Date.now(), // タイムスタンプがない場合は現在時刻を使用
                }
              : null;
          })
          .filter((item) => item !== null);
        // timestamp の降順で並べ替え
        setChatHistory(filteredData);
      }
    });
  }, [sessionId]);

  //履歴の折り畳み
  const toggleSection = (key) => {
    setOpenSections((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  // タイムスタンプを基準に履歴を分類する関数
  const filterMessagesByDate = (messages) => {
    const now = Date.now();
    const getDateDifference = (timestamp) =>  (now - timestamp) / (24 * 60 * 60 * 1000); // 日数換算
    
    messages = (messages || []).sort((a, b) => b.timestamp - a.timestamp);
    return {
      today: (messages || []).filter((msg) => getDateDifference(msg.timestamp) < 1),
      yesterday: (messages || []).filter((msg) => getDateDifference(msg.timestamp) >= 1 && getDateDifference(msg.timestamp) < 7),
      last7Days: (messages || []).filter((msg) => getDateDifference(msg.timestamp) >= 7 && getDateDifference(msg.timestamp) < 31),
      last30Days: (messages || []).filter((msg) => getDateDifference(msg.timestamp) >= 31)
    };
  };

  const filteredMessages = filterMessagesByDate(chatHistory);

  const getModeIcon = (mode) => {
    const iconStyle = { width: '20px', height: '20px', objectFit: 'contain' };
    switch (mode) {
      case 'faq':
        return <img style={iconStyle} src="/images/faq.png" alt="FAQ" />;
      case 'faqchat':
        return <img style={iconStyle} src="/images/faqchat.png" alt="FAQ" />;
      case 'manual':
        return <img style={iconStyle} src="/images/manual.png" alt="Manual" />;
      case 'support':
        return <img style={iconStyle} src="/images/support.png" alt="Support" />;
      case 'sendbak':
        return <img style={iconStyle} src="/images/sendbak.png" alt="SendBak" />;
      case 'chatgpt':
        return <img style={iconStyle} src="/images/chatgpt.png" alt="ChatGPT" />;
      case 'faqdoc':
        return <img style={iconStyle} src="/images/faqdoc.png" alt="Faqdoc" />;
      case 'csiaction':
        return <img style={iconStyle} src="/images/csiaction.png" alt="csiaction" />;
      case 'csinote':
        return <img style={iconStyle} src="/images/csiaction.png" alt="csinote" />;
      default:
        return null;
    }
  };

  // 履歴をロード
  const handleLoadHist = (index, messagesList) => {
    try {
      const selectedChat = messagesList[index];
      loadFromCache('chat-history-cache', selectedChat.id).then((data) => {
        //console.log('SideHistdate',data)
        if (data.length > 0) {
          //console.log('SideHistdate',data[0].messages)
          setMode(data[0].mode)
          setSessionId(selectedChat.id);
          setMessages(data[0].messages);
          
          // チャット画面を表示
          setDisplayMode('chat');
          setIsUploadMode(false);
          setActiveButton('chat');
        }
      }); 
    } catch (error) {
      console.error('Failed to load chat history:', error);
    }
  };

//履歴の削除ボタン押下
  const handleDeleteHistory = async (id) => {
    try {
      console.log('=== 履歴削除開始 ===');
      console.log('削除対象ID:', id);
      
      // 1. まず、現在のキャッシュデータを取得
      const currentCacheData = await loadTitleCache('chat-history-cache');
      console.log('削除前のキャッシュデータ:', currentCacheData);
      console.log('削除前の件数:', currentCacheData.length);
      
      // 2. メモリ上で削除対象を除外
      const updatedCacheData = currentCacheData.filter((chat) => chat.id !== id);
      console.log('削除後のデータ:', updatedCacheData);
      console.log('削除後の件数:', updatedCacheData.length);
      
      // 削除されたか確認
      const stillExists = updatedCacheData.find(c => c.id === id);
      console.log('削除対象がまだ存在するか:', stillExists ? 'YES (問題あり)' : 'NO (正常)');
      
      // 3. キャッシュに削除後のデータを保存
      const cache = await caches.open('chat-history-cache');
      await cache.put('chat-sessions', new Response(JSON.stringify(updatedCacheData)));
      console.log('✓ キャッシュ更新完了');
      
      // 4. ステートから削除（画面表示用）
      const updatedHistory = chatHistory.filter((chat) => chat.id !== id);
      setChatHistory(updatedHistory);
      
      // 5. CosmosDBにも反映（削除後のデータを保存）
      const userId = loginInfo.userId;
      const compId = loginInfo.compId;
      
      console.log('loginInfo.userId:', userId);
      console.log('loginInfo.compId:', compId);
      console.log('loginInfo.id:', loginInfo.id);
      
      if (!userId) {
        console.error('履歴削除エラー: userIdが取得できません');
        alert('ユーザー情報が取得できないため、CosmosDBへの反映をスキップしました。');
        return;
      }
      
      // con-concierge-histのid形式: compIdがある場合は "compId-userId"、ない場合は "userId"
      const historyId = compId ? `${compId}-${userId}` : userId;
      console.log('CosmosDB保存先ID:', historyId);
      
      const uppayload = {
        id: historyId,
        timestamp: Date.now(),
        messages: updatedCacheData.slice(0, 50), // 最新50件まで保持
        container: "con-concierge-hist"
      };
      
      console.log('=== CosmosDBに送信するペイロード ===');
      console.log('id:', uppayload.id);
      console.log('messages件数:', uppayload.messages.length);
      console.log('messages全体:', uppayload.messages);
      
      // 削除対象IDが含まれていないか最終チェック
      const foundInPayload = uppayload.messages.find(m => m.id === id);
      console.log('ペイロード内に削除対象が含まれているか:', foundInPayload ? 'YES (問題あり!)' : 'NO (正常)');
      if (foundInPayload) {
        console.error('⚠️ 警告: 削除したはずのIDがペイロードに含まれています!', foundInPayload);
      }
      
      console.log('SendToCosmosを呼び出します...');
      const result = await SendToCosmos(uppayload);
      console.log('SendToCosmos結果:', result);
      console.log('✅ 処理完了');
      
    } catch (error) {
      console.error('履歴削除エラー:', error);
      alert('履歴の削除に失敗しました。');
    }
  };


  const buttonStyles = {
    minWidth: 'auto',
    width: '100%',
    height: '20px',
    fontSize: '12px',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    justifyContent: 'flex-start',
    textAlign: 'left'
  };

  return (
    
    <div>
      
      <ul>
      {historySection.map(({ key, label }) => 
  filteredMessages[key].length > 0 && (
    <React.Fragment key={key}>
      <li>
        <strong
          style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
          onClick={() => toggleSection(key)}
        >
          {openSections[key] ? '▼' : '▶'} {label}
        </strong>
      </li>

      <Collapse in={openSections[key]}>
        {filteredMessages[key].map((msg, index) => (
          <div className="sidebar-history-child" key={index}>

              <Button
                onClick={() => handleLoadHist(index, filteredMessages[key])}
                startIcon={getModeIcon(msg.mode)}
                sx={buttonStyles}
              >
                <li className="sidebar-history-text">
                  <strong>{msg.title}</strong>
                </li>
              </Button> 

            <IconButton
              onClick={() => handleDeleteHistory(msg.id)}
              size="small"
              sx={{ fontSize: '10px', padding: '0px' }}
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
          </div>
        ))}
      </Collapse>
    </React.Fragment>
  )
)}
      </ul>
    </div>
  );
};

export default SidebarHistory;
